import React, { useState } from 'react'
import { bool, string } from 'prop-types'
import styled, { css } from 'styled-components'

import EmptyNav from 'components/Nav/EmptyNav'
import Nav from 'components/Nav'
import Announcement from './Announcement'
import { white, borderColor } from 'styles/colors'
import { animationTime, animationCurve } from 'styles/global'

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  width: 100%;
  background-color: ${props => (props.transparent ? 'transparent' : white)};
  box-shadow: 0 1px 0 0 ${props => (props.transparent ? 'transparent' : borderColor)};
  transition: background-color ${animationTime} ${animationCurve}, box-shadow ${animationTime} ${animationCurve};

  ${props =>
    props.noBackground &&
    css`
      background-color: transparent;
      box-shadow: none;
    `}

  ${props =>
    props.isSticky &&
    css`
      position: sticky;
    `}
`

const EmptyHeader = ({ message, transparent }) => (
  <Container
    transparent={transparent}
    css={`
      position: relative;
    `}
  >
    <EmptyNav transparent={transparent} message={message} />
    {message && (
      <Announcement
        message={`Vuse ecommerce is not supported in QC. Please see below for locations where Vuse products are available`}
      />
    )}
  </Container>
)

EmptyHeader.propTypes = {
  message: string,
  transparent: bool
}

const Header = ({ empty, transparent, noBackground, message, isSticky, hideLogin }) => {
  const [hovered, setHovered] = useState(false)

  const toggleHover = value => {
    setHovered(value)
  }

  if (empty) return <EmptyHeader transparent={transparent} message={message} />

  return (
    <Container isSticky={isSticky} transparent={transparent && !hovered} noBackground={noBackground && !hovered}>
      <Nav transparent={transparent && !hovered} hoverFunc={toggleHover} hoverState={hovered} hideLogin={hideLogin} />
    </Container>
  )
}

Header.propTypes = {
  empty: bool,
  transparent: bool,
  message: string,
  noBackground: bool,
  isSticky: bool,
  hideLogin: bool
}

export default Header
